import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-deployments-title-breadcrumbs.title',
		defaultMessage: 'Deployments',
		description:
			'This is the page title for Deployments page. Deployments page is where you can see code deployments state per issues/epic. Internal stakeholders come to this page and see where the code change is sitting.',
	},
	beta: {
		id: 'software-deployments-title-breadcrumbs.beta',
		defaultMessage: 'Beta',
		description:
			'A Lozenge for a feature that is only released to a few customers in Beta release.',
	},
});
